module.exports = __webpack_public_path__ + "static/26-455f09bb05a4c434715b0dedddc132d1.jpg";